const WARNING_RULES = [
        {
                test: (warning) => warning.startsWith("artigo_verificado_fontes_ilegiveis"),
                title: "Fontes que o Infinitum não conseguiu ler",
                detail: "Algumas fontes (por exemplo vídeos sem transcrição) não puderam ser lidas; o texto só usa o que foi verificado nas restantes.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("artigo_verificado_com_omissoes"),
                title: "Afirmações retiradas na verificação",
                detail: "O Infinitum escreveu e verificou o texto frase a frase; o que não se provou foi retirado. O relatório está no evidence pack do dossiê.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("correcao_sem_confirmacao_validacao_inconclusiva"),
                title: "Correção por confirmar",
                detail: "As frases sem suporte foram reescritas, mas a nova validação foi inconclusiva: o Infinitum não conseguiu ler evidência suficiente. Nada ficou confirmado pelas fontes.",
                tone: "risk",
        },
        {
                test: (warning) => warning.startsWith("afirmacoes_sem_suporte_restantes_apos_correcao"),
                title: "Afirmações ainda sem suporte",
                detail: "A correção automática reescreveu as frases sem suporte, mas a nova validação ainda encontrou algumas. Confirma-as antes de publicar.",
                tone: "risk",
        },
        {
                test: (warning) => warning.startsWith("afirmacoes_sem_suporte_corrigidas_automaticamente"),
                title: "Afirmações corrigidas automaticamente",
                detail: "As frases que as fontes não sustentavam foram reescritas pela IA e o texto foi validado de novo pelo Infinitum.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("reparacao_antigos_sem_ligacao_portugal"),
                title: "Repair enviou para revisão",
                detail: "A ferramenta de reparação antiga não encontrou eixo Portugal explícito e retirou o dossiê da publicação automática.",
                tone: "review",
                statusReason: true,
        },
        {
                test: (warning) => warning.startsWith("reparacao_antigos_exige_revisao_editorial"),
                title: "Revisão editorial obrigatória",
                detail: "Ainda existe um risco que não deve ser resolvido automaticamente. É preciso validação humana antes de publicar.",
                tone: "review",
                statusReason: true,
        },
        {
                test: (warning) => warning.startsWith("reparacao_antigos_publicacao_bloqueada"),
                title: "Publicação bloqueada pelo repair",
                detail: "A reparação tentou validar o dossiê, mas as regras editoriais impediram publicação direta.",
                tone: "review",
                statusReason: true,
        },
        {
                test: (warning) => warning.startsWith("titulo_reparado_por_modelo_editorial"),
                title: "Título reparado",
                detail: "O título foi regenerado pelo modelo editorial para ficar mais alinhado com o texto e as fontes.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("titulo_reparacao_rejeitada"),
                title: "Título não reparado",
                detail: "Nota técnica: o modelo sugeriu outro título, mas o sistema manteve o atual. Só exige ação se o título lido estiver realmente desalinhado.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("titulo_desalinhado_com_texto"),
                title: "Título desalinhado",
                detail: "O título não partilha entidades ou conceitos concretos suficientes com o corpo do dossiê.",
                tone: "risk",
        },
        {
                test: (warning) => warning.startsWith("titulo_parece_importado_de_fonte"),
                title: "Título parece importado de fonte",
                detail: "O título está lexicalmente mais próximo de uma fonte do que do texto gerado pelo dossiê.",
                tone: "risk",
        },
        {
                test: (warning) => warning.startsWith("titulo_gerado_substituido_por_fallback"),
                title: "Título substituído por fallback",
                detail: "O título gerado não passou nas regras editoriais e foi substituído por uma alternativa mais conservadora.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("titulo_gerado_precisa_revisao"),
                title: "Título precisa de revisão",
                detail: "Pré-alerta técnico sobre a forma do título. Se o texto, fontes e revisão contextual estiverem alinhados, pode ser apenas histórico da geração.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("citacoes_invalidas_removidas"),
                title: "Citações inválidas removidas",
                detail: "Havia referências inline para fontes inexistentes. A reparação removeu esses índices do texto.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("citacao_0_corrigida_para_1"),
                title: "Citação [0] corrigida",
                detail: "A IA gerou uma citação [0], que não existe na lista de fontes. Foi corrigida para [1].",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.includes("source_idx_corrigido_para"),
                title: "Fonte de facto corrigida",
                detail: "Um facto verificado apontava para uma fonte inválida e foi relinkado à fonte mais provável.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.includes("source_idx_invalido_removido"),
                title: "Fonte inválida removida de facto",
                detail: "Um facto tinha índice de fonte inválido e não havia correspondência segura para corrigir automaticamente.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("factos_reordenados_por_alinhamento_titulo"),
                title: "Factos reordenados",
                detail: "A cronologia foi reordenada para aproximar os factos principais do tema do título.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("fontes_de_apoio_sem_citacao_por_revisao_ia"),
                title: "Fontes de apoio sem citação direta",
                detail: "A revisão assistida manteve fontes finais que ajudam a sustentar a investigação, embora nem todas estejam ligadas a uma citação inline específica.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("fontes_nao_citadas_removidas_por_revisao_ia"),
                title: "Fontes não citadas removidas",
                detail: "Aviso antigo: uma revisão anterior compactou a lista final e removeu fontes sem citação ou ligação direta a factos verificados.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("citacoes_reparadas_por_revisao_ia"),
                title: "Citações revistas",
                detail: "A revisão automática ajustou citações ou ligações de factos antes de guardar o dossiê.",
                tone: "repair",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("reparacao_citacoes_ainda_com_avisos"),
                title: "Pré-alerta de citações",
                detail: "A verificação automática de sobreposição textual continuou prudente. Confirma manualmente apenas se a frase citada não estiver sustentada pela fonte.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("revisao_ia_aviso_nao_resolvido"),
                title: "Aviso não resolvido pela IA",
                detail: "A IA não encontrou base factual suficiente para resolver este ponto com segurança. Precisa de decisão editorial.",
                tone: "review",
                statusReason: true,
        },
        {
                test: (warning) => warning.startsWith("artigo_completo_curto"),
                title: "Artigo curto",
                detail: "O artigo ficou abaixo do mínimo editorial recomendado. Pode precisar de desenvolvimento antes de publicar.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("marcacoes_confidenciais_ausentes"),
                title: "Marcações confidenciais ausentes",
                detail: "Nota de estilo: o artigo não contém marcações [REDACT: ...]. Pode ser corrigido se o dossiê precisar desses destaques.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("intencao_ou_dolo_sem_prova_documental"),
                title: "Intenção não provada",
                detail: "O texto parece imputar intenção, dolo ou estratégia deliberada sem prova documental explícita. Reformula como efeito, enquadramento ou leitura editorial sustentada.",
                tone: "risk",
        },
        {
                test: (warning) => warning.startsWith("sem_fonte_documental_historica_ou_dados"),
                title: "Falta fonte documental ou dados",
                detail: "Nota de robustez: o dossiê usa sobretudo fontes jornalísticas. Não é, por si só, um erro se o texto não depender de alegações documentais fortes.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("fontes_citaveis_insuficientes_para_dossie_longo"),
                title: "Poucas fontes citáveis",
                detail: "Nota de robustez: há menos fontes com texto citável do que o ideal para um dossiê longo. Pode estar aceitável se o texto for estreito e bem sustentado.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("fontes_fracas_ou_sociais_presentes"),
                title: "Fontes frágeis ou sociais",
                detail: "Nota de robustez: há fontes sociais, agregadores ou fontes de apoio. Só exige ação se forem usadas como prova principal de um facto sensível.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("citacao_sem_suporte_textual"),
                title: "Citação com pouco suporte textual",
                detail: "Pré-alerta automático: a frase citada teve pouca sobreposição lexical com o texto conhecido da fonte. Pode ser falso positivo quando há paráfrase fiel.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.includes("sem_suporte_textual_na_fonte"),
                title: "Facto com pouco suporte na fonte",
                detail: "Pré-alerta automático: um facto teve pouca sobreposição lexical com a fonte indicada. Confirma apenas se a revisão contextual ou a leitura da fonte também levantar dúvida.",
                tone: "neutral",
                active: false,
        },
        {
                test: (warning) => warning.startsWith("slug_mantido_apos_titulo_reparado"),
                title: "URL mantido",
                detail: "O título mudou, mas o endereço público foi mantido para não partir ligações existentes.",
                tone: "repair",
                active: false,
        },
        // --- Motor de evidência do Infinitum: o que as fontes dizem sobre o artigo ---
        {
                test: (warning) => warning.startsWith("evidence_pack_claims_bloqueadas"),
                title: "Afirmações bloqueadas pelas fontes",
                detail: "O motor de evidência leu as fontes e estas afirmações não podem ser escritas como estão. Ver a lista na revisão contextual: reformular, juntar fonte ou retirar.",
                tone: "risk",
        },
        {
                test: (warning) =>
                        warning.startsWith("evidence_pack_nao_seguro") ||
                        warning.startsWith("evidence_pack_claims_sem_suporte"),
                title: "Afirmações sem suporte nas fontes",
                detail: "As fontes foram lidas e não sustentam parte do que o artigo afirma. É um resultado da validação, não uma falha técnica. Confirmar na revisão contextual antes de publicar.",
                tone: "risk",
        },
        {
                test: (warning) =>
                        warning.startsWith("evidence_pack_claims_a_reformular") ||
                        warning.startsWith("evidence_pack_claims_a_confirmar"),
                title: "Afirmações a confirmar ou reformular",
                detail: "O motor de evidência pede que estas afirmações sejam confirmadas numa fonte ou reescritas como alegação ou leitura editorial.",
                tone: "review",
        },
        {
                test: (warning) =>
                        warning.startsWith("evidence_pack_sem_prova_nacional_direta") ||
                        warning.startsWith("evidence_pack_limita_claims_nacionais"),
                title: "Sem prova oficial do país do tema",
                detail: "Não há documento oficial do país onde os factos acontecem a sustentar as afirmações. Escrevê-las como alegação, enquadramento ou efeito provável, não como facto provado.",
                tone: "review",
        },
        // --- Falhas técnicas: incompletas, não conclusões sobre o conteúdo ---
        {
                test: (warning) =>
                        warning.startsWith("evidence_pack_degradado") ||
                        warning.startsWith("validate_article_degradado") ||
                        warning.startsWith("evidence_pack_indisponivel"),
                title: "Validação contra as fontes incompleta",
                detail: "O motor de evidência teve uma falha técnica (fila, quota ou erro) e não validou o artigo até ao fim. Não quer dizer que as afirmações estejam erradas: repetir a revisão contextual mais tarde.",
                tone: "review",
        },
        {
                test: (warning) =>
                        warning.startsWith("evidence_pack_validacao_inconclusiva") ||
                        warning.startsWith("evidence_pack_requer_nova_validacao"),
                title: "Validação inconclusiva",
                detail: "O motor de evidência não conseguiu ler evidência suficiente para decidir. Repetir a revisão contextual ou juntar fontes com texto acessível.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("evidence_pack_extracao_deterministica"),
                title: "Triagem sem IA",
                detail: "As afirmações foram separadas por regras automáticas, sem a IA. Podem incluir paráfrases ou opinião editorial: confirmar na revisão contextual.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("extract_cobertura_incompleta"),
                title: "Fontes que não chegaram a ser lidas",
                detail: "Parte das fontes encontradas não foi lida pelo Infinitum, por isso o dossiê foi escrito com menos evidência do que podia. Repetir a geração ou a revisão mais tarde.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("extract_ia_indisponivel"),
                title: "Leitura das fontes sem IA",
                detail: "As fontes foram lidas, mas a IA do Infinitum não extraiu factos e citações. É temporário e técnico: não tratar as afirmações como infundadas por isso.",
                tone: "review",
        },
        {
                test: (warning) => warning.startsWith("extract_ia_requer_async"),
                title: "Extração por IA desligada",
                detail: "O Verdade Oculta pediu a leitura das fontes pelo caminho síncrono, que não usa a IA do Infinitum. Ligar INFINITUM_ASYNC_JOBS_ENABLED.",
                tone: "review",
        },
];

export const editorialStatusLabel = (status) => {
        if (status === "published") return "Publicado";
        if (status === "review") return "Em revisão";
        if (status === "draft") return "Pendente";
        if (status === "archived") return "Arquivado";
        return status || "Publicado";
};

const contextReviewClearsLegalRisk = (contextRiskReview) => {
        if (!contextRiskReview) return false;
        const findings = contextRiskReview.findings || [];
        if (findings.length > 0) return false;
        const assessment = String(contextRiskReview.overall_assessment || "").toLowerCase();
        return (
                (contextRiskReview.cleared_excerpts || []).length > 0 ||
                assessment.includes("publicável") ||
                assessment.includes("sem riscos") ||
                assessment.includes("não apresenta riscos")
        );
};

const warningKey = (value) => String(value || "").replace(/\s+/g, " ").trim().toLowerCase();

const contextWarningReview = (raw, contextRiskReview) => {
        const reviews = contextRiskReview?.warning_reviews || [];
        if (!Array.isArray(reviews) || reviews.length === 0) return null;
        const rawKey = warningKey(raw);
        return reviews.find((item) => {
                const itemKey = warningKey(item?.warning);
                return itemKey && (itemKey === rawKey || itemKey.includes(rawKey) || rawKey.includes(itemKey));
        }) || null;
};

export const qualityWarningDetails = (warnings = [], options = {}) =>
        (Array.isArray(warnings) ? warnings : [])
                .filter(Boolean)
                .map((warning) => {
                        const raw = String(warning);
                        const warningReview = contextWarningReview(raw, options.contextRiskReview);
                        const rule = WARNING_RULES.find((candidate) => candidate.test(raw));
                        if (rule) {
                                const legalRiskCleared =
                                        raw.startsWith("intencao_ou_dolo_sem_prova_documental") &&
                                        contextReviewClearsLegalRisk(options.contextRiskReview);
                                if (warningReview?.status === "resolved") {
                                        return {
                                                raw,
                                                title: `${rule.title} resolvido`,
                                                detail: warningReview.rationale || "A revisão contextual considerou este aviso resolvido no artigo completo.",
                                                tone: "neutral",
                                                active: false,
                                                statusReason: false,
                                        };
                                }
                                if (warningReview?.status === "attention") {
                                        return {
                                                raw,
                                                title: `${rule.title} em atenção`,
                                                detail: warningReview.rationale || rule.detail,
                                                tone: rule.tone === "risk" ? "review" : rule.tone,
                                                active: true,
                                                statusReason: Boolean(rule.statusReason),
                                        };
                                }
                                if (warningReview?.status === "active") {
                                        return {
                                                raw,
                                                title: rule.title,
                                                detail: warningReview.rationale || rule.detail,
                                                tone: rule.tone === "neutral" ? "review" : rule.tone,
                                                active: true,
                                                statusReason: Boolean(rule.statusReason),
                                        };
                                }
                                return {
                                        raw,
                                        title: legalRiskCleared
                                                ? "Intenção revista no contexto"
                                                : rule.title,
                                        detail: legalRiskCleared
                                                ? "Pré-alerta mantido no histórico, mas a revisão contextual não confirmou risco real no texto completo."
                                                : rule.detail,
                                        tone: legalRiskCleared ? "neutral" : rule.tone,
                                        active: legalRiskCleared
                                                ? false
                                                : rule.active ?? !["repair", "neutral"].includes(rule.tone),
                                        statusReason: Boolean(rule.statusReason),
                                };
                        }
                        if (warningReview?.status === "resolved") {
                                return {
                                        raw,
                                        title: "Aviso resolvido",
                                        detail: warningReview.rationale || "A revisão contextual considerou este aviso resolvido no artigo completo.",
                                        tone: "neutral",
                                        active: false,
                                        statusReason: false,
                                };
                        }
                        return {
                                raw,
                                title: "Aviso editorial",
                                detail: warningReview?.rationale || "Aviso técnico guardado pelo gerador ou pela auditoria. Deve ser lido antes de publicar.",
                                tone: warningReview?.status === "active" ? "risk" : "review",
                                active: true,
                                statusReason: false,
                        };
                });

export const activeWarningDetails = (warnings = [], options = {}) =>
        qualityWarningDetails(warnings, options).filter((warning) => warning.active);

export const technicalWarningDetails = (warnings = [], options = {}) =>
        qualityWarningDetails(warnings, options).filter((warning) => !warning.active);

export const statusReasonDetails = (topic = {}) => {
        const status = topic.editorial_status || "published";
        const warnings = qualityWarningDetails(topic.quality_warnings);
        const repairReasons = warnings.filter((warning) => warning.statusReason);

        if (repairReasons.length > 0) return repairReasons;

        if (status === "review") {
                return [
                        {
                                title: "Em revisão",
                                detail: "O dossiê foi colocado em revisão por decisão editorial ou por validação automática prudente.",
                                tone: "review",
                        },
                ];
        }
        if (status === "draft") {
                return [
                        {
                                title: "Pendente",
                                detail: "O dossiê ainda é rascunho e não está publicado. Pode faltar revisão, fontes ou decisão final.",
                                tone: "review",
                        },
                ];
        }
        if (status === "archived") {
                return [
                        {
                                title: "Arquivado",
                                detail: "O dossiê foi retirado da fila ativa e não deve ser tratado como publicação corrente.",
                                tone: "neutral",
                        },
                ];
        }
        return [];
};
